module.exports = __webpack_public_path__ + "static/img/cover.ddd78fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clans/cover.jpg
// module id = f+Ec
// module chunks = 1